export const recentPurchases = [
  { name: 'Jessica R.', city: 'Austin', country: 'United States', time: '2 minutes ago' },
  { name: 'Sofía L.', city: 'Buenos Aires', country: 'Argentina', time: '4 minutes ago' },
  { name: 'Emma W.', city: 'Manchester', country: 'United Kingdom', time: '7 minutes ago' },
  { name: 'Chloé D.', city: 'Montreal', country: 'Canada', time: '9 minutes ago' },
  { name: 'Hannah K.', city: 'Melbourne', country: 'Australia', time: '12 minutes ago' },
  { name: 'Lucía P.', city: 'Valencia', country: 'Spain', time: '15 minutes ago' },
  { name: 'Mariana C.', city: 'São Paulo', country: 'Brazil', time: '18 minutes ago' },
  { name: 'Ava T.', city: 'Auckland', country: 'New Zealand', time: '21 minutes ago' },
  { name: 'Camila V.', city: 'Mexico City', country: 'Mexico', time: '25 minutes ago' },
  { name: 'Ingrid S.', city: 'Stockholm', country: 'Sweden', time: '28 minutes ago' },
]
